// Activity Tracking API
import api, { type AxiosResponse } from './client';
import type {
  UserActivityLog,
  ActivityStats,
  QueryParams,
} from './types';

export const activityAPI = {
  // Activity Logs
  getActivityLogs: (params?: QueryParams): Promise<AxiosResponse<{ count: number; results: UserActivityLog[] }>> =>
    api.get('/core/activity-logs/', { params }),

  getActivityLog: (id: number): Promise<AxiosResponse<UserActivityLog>> =>
    api.get(`/core/activity-logs/${id}/`),

  getActivityStats: (): Promise<AxiosResponse<ActivityStats>> =>
    api.get('/core/activity-logs/stats/'),
};
